// Cognito `sub` values allowed to see admin UI.
// Keep in sync with the backend allow list (config/admin.py).
export const ALLOWED_ADMIN_SUBS = new Set([
  "c14bb510-e0b1-7037-0380-c38405c3b7eb",
  "54188428-d011-7091-2456-21687dde5eaf",
]);

export const SAO_PAULO_TZ = "America/Sao_Paulo";

export const CHECKOUT_FUNNEL_LABELS = {
  checkout_enter: "Entrou no checkout",
  checkout_fill_personal_info: "Preencheu dados pessoais",
  checkout_fill_cpf: "Preencheu CPF",
  checkout_generate_pix: "Gerou pix",
  checkout_fill_card_info: "Preencheu dados do cartão",
  checkout_fill_payment_info: "Preencheu pagamento",
  checkout_pay: "Pagou",
};

export const CHECKOUT_PAYMENT_SPLIT_STEPS = [
  {
    eventName: "checkout_generate_pix",
    color: "#1d8a80",
  },
  {
    eventName: "checkout_fill_card_info",
    color: "#072959",
  },
];

export const SUBSCRIPTION_STATUS_LABELS = {
  ACTIVE: "Ativa",
  EXPIRED: "Expirada",
  CANCELLED: "Cancelada",
};

export const CHECKOUT_VALIDATION_LABELS = {
  name: "Nome",
  email: "E-mail",
  phone: "Telefone",
  cpf: "CPF",
  card_name: "Nome no cartão",
  card_number: "Número do cartão",
  card_expiry: "Validade do cartão",
  card_cvv: "CVV",
  n_inst: "Parcelas",
  cep: "CEP",
  rua: "Rua",
  numero: "Número",
  bairro: "Bairro",
  cidade: "Cidade",
  estado: "Estado",
  email_already_used: "E-mail já cadastrado",
};

export function getUserSub(user) {
  if (!user) return null;
  return user.attributes?.sub || user.cognitoUser?.username || null;
}

export function getSubFromToken(token) {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
    const json = JSON.parse(atob(padded));
    return json.sub || null;
  } catch {
    return null;
  }
}

export function isAllowedAdminSub(sub) {
  return Boolean(sub && ALLOWED_ADMIN_SUBS.has(sub));
}

export function isAllowedAdmin(user, token) {
  const sub = getSubFromToken(token) || getUserSub(user);
  return isAllowedAdminSub(sub);
}

export function todayInSaoPaulo() {
  return new Date().toLocaleDateString("en-CA", { timeZone: SAO_PAULO_TZ });
}

export function addCalendarDays(ymd, days) {
  const [year, month, day] = String(ymd).split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export const ALL_TIME_START_DATE = "2019-01-01";

export function defaultAdminDateRange(days = 30) {
  const endDate = todayInSaoPaulo();
  const startDate = addCalendarDays(endDate, -(days - 1));
  return { startDate, endDate };
}

export function allTimeAdminDateRange() {
  return { startDate: ALL_TIME_START_DATE, endDate: todayInSaoPaulo() };
}

export function formatDateBr(value) {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) {
      const [year, month, day] = String(value).split("-");
      return `${day}/${month}/${year}`;
    }
    return "—";
  }
  return date.toLocaleDateString("pt-BR", {
    timeZone: SAO_PAULO_TZ,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateTimeBr(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("pt-BR", {
    timeZone: SAO_PAULO_TZ,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatBRL(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return Number(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatPercent(ratio) {
  if (ratio === null || ratio === undefined || Number.isNaN(Number(ratio))) {
    return "—";
  }
  return `${(Number(ratio) * 100).toLocaleString("pt-BR", {
    maximumFractionDigits: 1,
  })}%`;
}

export function formatInteger(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return Number(value).toLocaleString("pt-BR");
}
